<template>
  <div class="bg-white m-3 rounded-md">
    <div class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center p-3">
      <div class="flex gap-3">
    <div
        v-for="(tab, index) in visibleTabs"
        :key="index"
        @click="changeTab(tab.title)"
        :class="{
              ' text-white bg-primary': selectedTab == tab.title,
            }"
        class="text-sm text-center hover:bg-primary bg-gray-200 hover:text-white cursor-pointer p-3"
    >
      {{ tab.title }}
    </div>
  </div>

    </div>
    <create-monthly-review v-if="selectedTab==='Create Review'" />
    <employee-monthly-reviews  v-if="selectedTab==='Employee Reviews'" />
    <my-monthly-review v-if="selectedTab==='My Reviews'" />
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import CreateMonthlyReview from "@/components/PerformanceReview/MonthReview/createMonthlyReview";
  import EmployeeMonthlyReviews from "@/components/PerformanceReview/MonthReview/employeeMonthlyReviews";
  import MyMonthlyReview from "@/components/PerformanceReview/MonthReview/myMonthlyReview";

  export default {
    name:"Monthly Review",
    components: {MyMonthlyReview, EmployeeMonthlyReviews, CreateMonthlyReview},
    data(){
      return {
        selectedTab: "My Reviews",
        frKey: 0,
        fgKey: 1,
        fkKey:3,
        tabs:[
          {
            title:'My Reviews',
            user:'all'
          },
          {
            title:'Employee Reviews',
            user:'manager'
          },
          {
            title:'Create Review',
            user:'manager'
          },
        ],

      }
    },
    computed:{
      ...mapGetters(["getOrganization", "getToken", "getUserType"]),
      visibleTabs() {
        if (this.getUserType.toLowerCase()==='hr manager' || this.getUserType.toLowerCase()==='manager'){
          return this.tabs
        } else {
          return this.tabs.filter((tab) => tab.user==='all');
        }

      },
    },
    methods:{
      changeTab(tab) {
        console.log("user type", this.getUserType)
        this.selectedTab = tab;
        switch (this.selectedTab) {
          case "My Reviews":
            this.frKey++;
            break;
          case "Employee Reviews":
            this.fgKey++;
            break;
          case "Create Review":
            this.fkKey;
            break;
        }
      },
    }
  }
</script>